/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IAuthApi {
    checkCaptcha(m: CheckCaptchaRequest, cancelToken?: CancelToken): AxiosPromise<void>;
    getReCaptchaSiteKey(cancelToken?: CancelToken): AxiosPromise<string>;
    getEnvironmentInfo(isMobile: boolean | undefined, cancelToken?: CancelToken): AxiosPromise<LoginEnvironmentInfo>;
    forgotPassword(model: ForgotPasswordRequestModel, cancelToken?: CancelToken): AxiosPromise<string>;
    forgotPasswordVerifyCode(model: ForgotPasswordVerifyCodeRequestModel, cancelToken?: CancelToken): AxiosPromise<void>;
    resetPasswordByCode(model: ResetPasswordByCodeRequest, cancelToken?: CancelToken): AxiosPromise<ResetPasswordResponseModel>;
    resetPassword(userId: number, m: ResetPasswordRequest, cancelToken?: CancelToken): AxiosPromise<ResetPasswordResponseModel>;
    sendInvitation(model: SendInvitationRequestModel, cancelToken?: CancelToken): AxiosPromise<void>;
    validateRegistrationLink(model: ValidateRegistrationLinkRequest, cancelToken?: CancelToken): AxiosPromise<void>;
}

@injectable()
export class AuthApi implements IAuthApi {
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@inject("baseUrl") @optional() baseUrl?: string) {
        this.baseUrl = baseUrl || "";
    }

    checkCaptcha(m: CheckCaptchaRequest, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = this.baseUrl + "/app/api/auth/CheckCaptcha";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = m;

        let options_ = <AxiosRequestConfig>{
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }

    getReCaptchaSiteKey(cancelToken?: CancelToken): AxiosPromise<string> {
        let url_ = this.baseUrl + "/app/api/auth/GetReCaptchaSiteKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<string>(options_));
    }

    getEnvironmentInfo(isMobile: boolean | undefined, cancelToken?: CancelToken): AxiosPromise<LoginEnvironmentInfo> {
        let url_ = this.baseUrl + "/app/api/auth/GetEnvironmentInfo?";
        if (isMobile === null)
            throw new Error("The parameter 'isMobile' cannot be null.");
        else if (isMobile !== undefined)
            url_ += "isMobile=" + encodeURIComponent("" + isMobile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<LoginEnvironmentInfo>(options_));
    }

    forgotPassword(model: ForgotPasswordRequestModel, cancelToken?: CancelToken): AxiosPromise<string> {
        let url_ = this.baseUrl + "/app/api/auth/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = model;

        let options_ = <AxiosRequestConfig>{
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<string>(options_));
    }

    forgotPasswordVerifyCode(model: ForgotPasswordVerifyCodeRequestModel, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = this.baseUrl + "/app/api/auth/ForgotPasswordVerifyCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = model;

        let options_ = <AxiosRequestConfig>{
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }

    resetPasswordByCode(model: ResetPasswordByCodeRequest, cancelToken?: CancelToken): AxiosPromise<ResetPasswordResponseModel> {
        let url_ = this.baseUrl + "/app/api/auth/ResetPasswordByCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = model;

        let options_ = <AxiosRequestConfig>{
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ResetPasswordResponseModel>(options_));
    }

    resetPassword(userId: number, m: ResetPasswordRequest, cancelToken?: CancelToken): AxiosPromise<ResetPasswordResponseModel> {
        let url_ = this.baseUrl + "/app/api/auth/ResetPassword/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = m;

        let options_ = <AxiosRequestConfig>{
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ResetPasswordResponseModel>(options_));
    }

    sendInvitation(model: SendInvitationRequestModel, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = this.baseUrl + "/app/api/auth/SendInvitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = model;

        let options_ = <AxiosRequestConfig>{
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }

    validateRegistrationLink(model: ValidateRegistrationLinkRequest, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = this.baseUrl + "/app/api/auth/ValidateRegistrationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = model;

        let options_ = <AxiosRequestConfig>{
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }
}

export interface CaptchaResponse {
    gRecaptchaResponse?: string | undefined;
}

export interface CheckCaptchaRequest extends CaptchaResponse {
    gRecaptchaResponse: string;
    isAndroid: boolean;
    username?: string;
    isInvisibleCaptcha: boolean;
}

export interface LoginEnvironmentInfo {
    isCaptchaEnabled: boolean;
    environmentName?: string | undefined;
}

export interface ForgotPasswordRequestModel extends CaptchaResponse {
    name: string;
}

export interface ForgotPasswordVerifyCodeRequestModel extends CaptchaResponse {
    token: string;
    code: string;
}

export interface ResetPasswordResponseModel {
    type: UserType;
    userName?: string | undefined;
}

export enum UserType {
    Unknown = 0,
    Employee = 1,
    Technician = 2,
    External = 3,
    Supervisor = 4,
}

export interface ResetPasswordByCodeRequest {
    code: string;
    token: string;
    password: string;
}

export interface ResetPasswordRequest {
    username: string;
    token: string;
    password: string;
    byEmail: boolean;
    isInvitation: boolean;
}

export interface SendInvitationRequestModel {
    name: string;
}

export interface ValidateRegistrationLinkRequest {
    token: string;
    userId: number;
}
